module.exports = __webpack_public_path__ + "static/media/logo.22bf4954.png";